import React from 'react'
import PropTypes from 'prop-types'
import './style.css'


const NRTListItem = (props) => {

    const {
        onClick,
        noBorder,
        className,
        style,
        showOnlySeparator,
    } = props

    const clickableCls = !onClick ? 'not-clickable' : ' '
    const showOnlySeparatorCls = showOnlySeparator ? ' show-only-separator ' : ''
    const noBorderCls = noBorder ? ' no-border ' : ''


    return (
        <li
            onClick={!!onClick ? onClick : ()=>null }
            style={style}
           

            className={'nrt-list-item ' + clickableCls + ' ' + className + showOnlySeparatorCls + noBorderCls}
        >

            {props.children}
        </li>
    )
}

NRTListItem.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    noBorder: PropTypes.bool,
    showOnlySeparator: PropTypes.bool
}

NRTListItem.defaultProps = {
    onClick : null ,
    className: '',
    style: {},
    noBorder: false,
    showOnlySeparator: false
}

export default NRTListItem



// WEBPACK FOOTER //
// ./src/components/_common/ListItem/index.js